export default __webpack_public_path__ + "static/media/file3.0aab720a.jpg";